import React, {useEffect, useState} from 'react';
import {Button, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {connect} from 'react-redux';
import {ENTITY_TYPE_NAME_MAP, forceJsonResponse} from 'common/utils';
import {MONO} from 'app-ui-componentlibrary/dist/common/constants';

const SaveForLater = ({
  dataEntityId,
  userId,
  toggles,
  onSaveUnsave,
  entityType,
  taskContext,
}) => {
  if (!_.includes(toggles, 'disasterSiteNav')) return <></>;
  const [savedToCurrent, setSavedToCurrent] = useState(false);
  const [saveForLaterId, setSaveForLaterId] = useState('');
  const [dataType, setDataType] = useState('');
  const [taskId, setTaskId] = useState('');
  const [entityId, setEntityId] = useState('');
  const [entityName, setEntityName] = useState('');
  const [showSave, setShowSave] = useState(false);

  useEffect(() => {
    const url = window.location.href;
    const excludedPagesRegex = [
      /\/view/,
      /\/fundingOpportunity\/draft/,
      /fundingOpportunity\/-?\d+/,
    ];

    setShowSave(!excludedPagesRegex.some((regex) => regex.test(url)));
  }, []);

  useEffect(() => {
    if (showSave) {
      if (taskContext) {
        setEntityName(_.get(taskContext, 'task.name', ''));
        setEntityId(_.get(taskContext, 'processVariables.entityId', ''));
        setTaskId(dataEntityId);
        setDataType('task');
      } else {
        setEntityName(_.get(ENTITY_TYPE_NAME_MAP, entityType, ''));
        setEntityId(dataEntityId);
        setDataType('data');
      }
      checkSavedToUser();
    }
  }, [showSave]);
  const checkSavedToUser = async () => {
    if (taskContext) {
      await REST.dynamicData
        .getSavedForUserByTaskId(dataEntityId)
        .then((res) => {
          if (res.ok) {
            return forceJsonResponse(res, MONO);
          } else return Promise.resolve({});
        })
        .then((data) => {
          // if not saved, data will have null userId
          setSavedToCurrent(data.userId === userId);
          setSaveForLaterId(data.id);
        })
        .catch((e) => {
          console.error('failed to check if entity is saved to user');
        });
    } else {
      await REST.dynamicData
        .getSavedForUserByEntityId(dataEntityId)
        .then((res) => {
          if (res.ok) {
            return forceJsonResponse(res, MONO);
          } else return Promise.resolve({});
        })
        .then((data) => {
          setSavedToCurrent(data.userId == userId);
          setSaveForLaterId(data.id);
        })
        .catch((e) => {
          console.error('failed to check if entity is saved to user');
        });
    }
  };
  const saveToCurrent = () => {
    REST.dynamicData
      .saveForLater({entityId, taskId, entityName, dataType})
      .then((res) => {
        if (res.ok) {
          //true to indicate save happened
          onSaveUnsave(true);
          setSavedToCurrent(true);
          checkSavedToUser();
        }
      });
  };
  const unSaveFromCurrent = () => {
    REST.dynamicData.unsaveForLater(saveForLaterId).then((res) => {
      if (res.ok) {
        // false to indicate unsave happened
        onSaveUnsave(false);
        setSavedToCurrent(false);
      }
    });
  };

  const handleClick = () => {
    if (savedToCurrent) unSaveFromCurrent();
    else saveToCurrent();
  };
  return (
    <>
      {showSave ? (
        <Button id="saveForLaterButton" className="save-for-later" onClick={handleClick}>
          <div className="saveForLaterBlock">
            <div>
              <img
                className="save-for-later-star"
                src={
                  savedToCurrent ? '/assets/star-filled.svg' : '/assets/star-unfilled.svg'
                }
              />
            </div>
            <div className="saveForLaterText">
              {savedToCurrent ? 'Saved for later' : 'Save for later'}
            </div>
          </div>
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    dataEntityId: _.get(state, 'dynamicComponent.data.entityId'),
    entityType: _.get(state, 'dynamicComponent.data.entityType'),
    userId: _.get(state, 'auth.userId'),
    token: _.get(state, 'auth.token'),
    toggles: _.get(state, 'dynamicComponent.context.toggles.toggles'),
  };
};
export default connect(mapStateToProps)(SaveForLater);
